import { stylesheet } from "typestyle";
export const typographyStyles = {
    alignCenter: {
        textAlign: "center"
    },
    alignRight: {
        textAlign: "right"
    },
    title: {
        fontSize: "1.5rem",
        fontWeight: 500,
    },
    description: {
        fontSize: "1rem",
        fontWeight: 300,
    },
    caption: {
        fontWeight: 300,
        fontSize: "1.25em",
    },
    muted: {
        opacity: 0.75
    },
    colorSuccess: {
        color: "var(--color-success)"
    },
    colorError: {
        color: "var(--color-error)"
    },
    monospace: {
        fontFamily: 'monospace'
    },
    bigger: {
        fontSize: "1.25em",
    },
    smaller: {
        fontSize: "0.875em",
    },
    reset: {
        fontSize: "1.rem",
    }
};
export const typography = stylesheet(typographyStyles);
//# sourceMappingURL=typography.js.map